
import { set as  setNotification } from '../../../state/notification/actions';
import {createGlobalRulesForApi,createODRulesForApi} from '../countryrules/helperTransformer';
import { FORM_TYPES } from '../../../state/tabs/tab/selectedForm/constants';
import { createHttpClient } from '../httpClient';
import config from '../../../../configs/config';


export const createCountryRules = async (
  fields,
  selectedCountry,
  selectedForm,
  settings,
  id
) => {
  let globalCountryRules = { globalRules: {} };
  let odRules = {};
  if(selectedForm === FORM_TYPES.GLOBAL){
    const {
        'avoid': globalAvoid,
        'avoid[features]': globalAvoidFeatures,
        'vehicle[speedCapPerFc]': globalVehicleSpeedCap,
        'exclude': globalExclude
    } = fields;
    globalCountryRules = createGlobalRulesForApi(globalAvoidFeatures, globalAvoid, globalVehicleSpeedCap, globalExclude);
    
  } else {
    const {
      'odRuleName':name,
      'avoid': odAvoid,
      'avoid[features]': odAvoidFeatures,
      'vehicle[speedCapPerFc]': odVehicleSpeedCap,
      'exclude': odExclude,
      'origin': odOrigin,
      'destination': odDestination,
      via
    } = fields;
    
    odRules = createODRulesForApi(id, odAvoidFeatures, odAvoid, odVehicleSpeedCap, odExclude, odOrigin, odDestination, via, name);
  }
  const payload = {
    ...globalCountryRules,
    ...odRules
  }

  const httpClient = createHttpClient(settings);
  return await httpClient.put(`${config.COUNTRY_RULES}/${selectedCountry}`, payload);
};

export const submitGlobalCountryRules = async (fields, country, settings) => {
  const {
    'avoid': globalAvoid,
    'avoid[features]': globalAvoidFeatures,
    'vehicle[speedCapPerFc]': globalVehicleSpeedCap,
    'exclude': globalExclude
  } = fields;
  
  const globalCountryRules = createGlobalRulesForApi(globalAvoidFeatures, globalAvoid, globalVehicleSpeedCap, globalExclude);
  
  const httpClient = createHttpClient(settings);
  return await httpClient.patch(`${config.COUNTRY_RULES}/${country}`, globalCountryRules);
};

export const submitODCountryRules = async (fields, country, settings, id) => {
  const {
    'odRuleName':name,
    'avoid': odAvoid,
    'avoid[features]': odAvoidFeatures,
    'vehicle[speedCapPerFc]': odVehicleSpeedCap,
    'exclude': odExclude,
    'origin': odOrigin,
    'destination': odDestination,
    via
  } = fields;
  
  const odCountryRules = createODRulesForApi(id, odAvoidFeatures, odAvoid, odVehicleSpeedCap, odExclude, odOrigin, odDestination, via, name);
  
  const httpClient = createHttpClient(settings);
  return await httpClient.patch(`${config.COUNTRY_RULES}/${country}`, odCountryRules);
};

export const deleteODCountryRules = async (country, settings, id) => {

  const odCountryRules = {
        originDestinationRules:{
          [id]: null
        }
    };
  
  const httpClient = createHttpClient(settings);
  return await httpClient.patch(`${config.COUNTRY_RULES}/${country}`, odCountryRules);
};

export const fetchCountryRules = async(settings,country) =>{
    try {
      const httpClient = createHttpClient(settings);
      return await httpClient.get(`${config.COUNTRY_RULES}/${country}`);
    } catch (e) {
      setNotification({
        message: `Failed to fetch country rules: "${e.message}"`,
        impact: 'negative',
        autoDismiss: 5,
      });
    }
};


export const fetchSupportedCountries = async(settings) =>{
    try {
      const httpClient = createHttpClient(settings);
      return await httpClient.get('/i/supportedcountries');
    } catch (e) {
      setNotification({
        message: `Failed to fetch country rules: "${e.message}"`,
        impact: 'negative',
        autoDismiss: 5,
      });
    }
};